import React from 'react';

export function MapSection() {
  return (
    <section id="s-map" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-map" data-reveal>
          <div className="franchise-map__banner">
            ГДЕ ОТКРОЕТСЯ СЛЕДУЮЩИЙ SUSHIBOX?
          </div>
          <div className="franchise-map__text-box">
            <div>
              Мы уже работаем <br /> в десятках городов России
            </div>
            <div>
              Следующая успешная точка <br /> может открыться именно у вас
            </div>
          </div>
          <div>
            <img className="franchise-map__map" src="/assets/media/franchise/hero-section/map.svg" alt="Карта" />
            <img className="franchise-map__location" src="/assets/media/franchise/map-section/location.svg" alt="Локация" />
            <img className="franchise-map__marks" src="/assets/media/franchise/map-section/group.svg" alt="Метки" />
            <div className="franchise-map__text">  Возможно, именно здесь <br /> откроется следующий SUSHIBOX!</div>
          </div>
          <img className="franchise-map__fish" src="/assets/media/franchise/map-section/fish.svg" alt="Рыбки" />
        </div>
      </div>
    </section>
  );
}
